import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import HeaderLinks from 'components/header/HeaderLinks/HeaderLinks';
import QuickEditOverlay from 'components/admin-bridge/QuickEditOverlay';
import AdminHeaderLinks from 'components/admin-bridge/AdminHeaderLinks';
import NavigationBlockWrapper from 'components/admin-bridge/NavigationBlockWrapper';
import { setNavigationSelectedInTheDropdown } from 'services/navigationv2';
import NavigationBar from '../NavigationBar';

const StyledQuickEditOverlay = styled(QuickEditOverlay)`
  display: flex;
  flex-grow: 1;
  min-width: 0;
  height: 100%;

  ${({ isAdmin }) => isAdmin && css`
    & > div:first-child {
      position: relative;
    }
  `};
`;

export default class HeaderLinksQuickEditOverlay extends React.Component {
  state = {
    actionModalOpen: false,
  };

  static propTypes = {
    className: PropTypes.string,
    containerRef: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    currentRoute: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    isFloatMenuOpen: PropTypes.bool.isRequired,
    isNavigationEnabledOnPage: PropTypes.bool.isRequired,
    isNavigationV1Enabled: PropTypes.bool.isRequired,
    isSimpleModeEnabled: PropTypes.bool.isRequired,
    navDoc: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    positionMenu: PropTypes.func.isRequired,
    saveGateNavigation: PropTypes.func,
    siteDomain: PropTypes.string.isRequired,
    toggleMenu: PropTypes.func.isRequired,
    trackHeader: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
    saveGateNavigation: undefined,
  };

  renderLegacyDefaultView = () => {
    const {
      currentRoute,
      className,
      siteDomain,
      trackHeader,
      navDoc,
    } = this.props;

    return (
      <HeaderLinks
        className={className}
        currentRoute={currentRoute}
        navDoc={navDoc}
        siteDomain={siteDomain}
        trackHeader={trackHeader}
      />
    );
  };

  renderLegacyEditableNavigation = () => {
    const { actionModalOpen } = this.state;
    const { saveGateNavigation, navDoc } = this.props;

    return (
      <AdminHeaderLinks
        actionModalOpen={actionModalOpen}
        navDoc={navDoc}
        onCloseActionModal={this.handleCloseActionModal}
        saveGateNavigation={saveGateNavigation}
      />
    )
  };

  handleOpenActionModal = () => {
    this.setState({ actionModalOpen: true });
    const { toggleMenu, dispatch } = this.props;
    dispatch(setNavigationSelectedInTheDropdown(''));
    toggleMenu();
  };

  handleCloseActionModal = () => {
    this.setState({ actionModalOpen: false });
    const { toggleMenu } = this.props;
    toggleMenu();
  };

  renderLegacyHeader = () => {
    const {
      isEditMode,
      isSimpleModeEnabled,
      isAdmin,
    } = this.props;

    const renderEditable = isSimpleModeEnabled ? isAdmin : isEditMode;

    if (renderEditable) {
      return this.renderLegacyEditableNavigation();
    }

    return this.renderLegacyDefaultView();
  };

  renderNavigationV1Header = () => {
    const {
      isEditMode,
      isSimpleModeEnabled,
      isAdmin,
      isNavigationEnabledOnPage,
      isFloatMenuOpen,
      positionMenu,
    } = this.props;

    const shoudRenderEditable = isSimpleModeEnabled ? isAdmin : isEditMode;

    return (
      <>
        {isNavigationEnabledOnPage && <NavigationBar />}
        {shoudRenderEditable && isFloatMenuOpen && (
          <NavigationBlockWrapper ref={positionMenu} />
        )}
      </>
    );
  };

  render() {
    const { containerRef, isAdmin, isNavigationV1Enabled } = this.props;

    return (
      <StyledQuickEditOverlay
        ref={containerRef}
        isAdmin={isAdmin}
        onEdit={this.handleOpenActionModal}
        testId="editNavigationLanding"
        titleKey="NAVIGATION"
      >
        {isNavigationV1Enabled ? this.renderNavigationV1Header() : this.renderLegacyHeader()}
      </StyledQuickEditOverlay>
    );
  }
}
